import React, { Fragment } from "react";

import { EmptyImages, ProductImageRenditions } from "@utils/enums";
import { doesVideoThumbnailNeedOverlay } from "@utils/imageViewer";

import { Image } from "@components/Product/ProductImage/imageWrapper/image/image.component";

export interface ProductMedia {
    thumbnail?: string;
    maxZoom?: string;
    main?: string;
    zoom?: string;
    altText?: string;
    videoId?: string;
}

type Props = {
    media: ProductMedia;
    defaultVideoThumbnailPath?: string;
    lazyLoad?: boolean;
};

const SlideThumbnail = ({
    media,
    defaultVideoThumbnailPath,
    lazyLoad,
}: Props) => {
    const imageUrl =
        (media.videoId ? media.thumbnail : media.main) ||
        defaultVideoThumbnailPath;

    if (!imageUrl) return <Fragment />;

    return (
        <Fragment>
            {media.videoId && doesVideoThumbnailNeedOverlay(media.main) && (
                <div className="imageViewer-overlay" />
            )}
            <Image
                className={"h-100 mh-100"}
                lazyLoad={lazyLoad}
                parentFit={false}
                altText={media.altText}
                defaultImageUrl={EmptyImages.Size_146_109}
                medias={[
                    {
                        altText: media.altText,
                        url: imageUrl,
                        format: ProductImageRenditions.XS,
                    },
                ]}
                rendition={ProductImageRenditions.XS}
            />
        </Fragment>
    );
};

export { SlideThumbnail };
